import {
  NumericDataEntity,
  NumericDataType
} from './../../../../../models/data-entities/numeric-data-entity';
import { Component, OnInit, ComponentFactoryResolver, Input } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-numeric-data-entity-view',
    templateUrl: './numeric-data-entity-view.component.html',
    styleUrls: ['./numeric-data-entity-view.component.css'],
    standalone: false
})
export class NumericDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  numericDE: NumericDataEntity;
  NumericDataType = NumericDataType;
  templateForPermitForm: boolean = false;         // Added by Vipul on 05/01/2026

  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context : WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
    // Started by Vipul on 05/01/2026
    layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 05/01/2026
  }

  ngOnInit() {
    this.numericDE = this.entity as NumericDataEntity;
    this.numericDE.value = this.numericDE.value || '';
  }
}
